// Checkout Flow
export const START_CHECKOUT = 'START_CHECKOUT';
export const START_CHECKOUT_SUCCESS = 'START_CHECKOUT_SUCCESS';
export const START_CHECKOUT_ERROR = 'START_CHECKOUT_ERROR';

export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_ERROR = 'CANCEL_SUBSCRIPTION_ERROR';

export const REACTIVATE_SUBSCRIPTION = 'REACTIVATE_SUBSCRIPTION';
export const REACTIVATE_SUBSCRIPTION_SUCCESS =
  'REACTIVATE_SUBSCRIPTION_SUCCESS';
export const REACTIVATE_SUBSCRIPTION_ERROR = 'REACTIVATE_SUBSCRIPTION_ERROR';
